import Loc from '../services/localization';

const LocService = new Loc();

export default {
    props: [
        'locale',
        'selectedBalanceUser',
        'balanceHistory',
        'balanceHistoryPage',
        'balanceHistoryLimit',
        'balanceHistoryTotal',
        'isLoadingBalanceHistory',
        'isAdjustingBalance',
        'balanceAdjustAmount',
        'balanceAdjustNote'
    ],
    methods: {
        getBalanceClass(amount){
            const value = parseFloat('' + (amount != null ? amount : 0));
            if(!Number.isFinite(value)) return 'is-neutral';
            if(value < 0) return 'is-negative';
            if(value > 0) return 'is-positive';
            return 'is-neutral';
        },
        formatBalanceAmount(amount){
            const value = parseFloat('' + (amount != null ? amount : 0));
            if(!Number.isFinite(value)) return '0.00';
            return value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },
        mapBalanceSourceType(sourceType){
            if(sourceType === 'BILL_CREATE') return LocService.t('label_balance_source_bill_create');
            if(sourceType === 'BILL_CANCEL_RETURN') return LocService.t('label_balance_source_bill_cancel_return');
            if(sourceType === 'BILL_MARK_PAID') return LocService.t('label_balance_source_bill_mark_paid');
            if(sourceType === 'MOBILE_APP_CREDIT_USE') return LocService.t('label_balance_source_mobile_app_credit_use');
            if(sourceType === 'ADMIN_ADJUSTMENT') return LocService.t('label_balance_source_admin_adjustment');
            return sourceType || '/';
        },
        mapBalanceChangeType(changeType){
            if(changeType === 'DEBIT') return LocService.t('label_balance_change_debit');
            if(changeType === 'CREDIT') return LocService.t('label_balance_change_credit');
            return changeType || '/';
        },
        formatBalanceTimestamp(timestamp){
            if(timestamp == null) return '/';
            const numeric = Number(timestamp);
            if(!Number.isFinite(numeric)) return '' + timestamp;
            return this.$moment(new Date(numeric * 1000)).format('DD-MM-YYYY HH:mm');
        }
    }
}



// WEBPACK FOOTER //
// ./src/modals/UserBalanceHistoryModal.js